import $ from 'gridstrap/lib/gs-zepto';
import { screenshotCarousel } from '.';

export class GSScreenshotCarousel {

	//
	// Properties
	//

	root;
	document;
	viewport;
	viewportWidth;
	viewportHeight;
	widthClearance;
	heightClearance;

	prevButton;
	nextButton;
	closeButton;
	activeItem;
	slider;

	get isSliding() { return this.slider.hasClass('is-sliding'); }
	get sliderOffset() { return this.slider.offset().left; }
	set sliderOffset(value) { this.slider.css('left', Math.floor(value)); }

	set isOpen(value) { this.root.addClass(value ? 'is-open' : 'is-closing'); }
	set isLoaded(value) { this.root.toggleClass('is-loaded', !!value); }
	set isSliding(value) { this.slider.toggleClass('is-sliding', !!value); }

	//
	// Methods
	//

	prev() {
		if (!this.activeItem.prevItem) return;
		this.activeItem.prevItem.select();
	}

	next() {
		if (!this.activeItem.nextItem) return;
		this.activeItem.nextItem.select();
	}

	align() {
		if (!this.activeItem) return;
		const { offset, width } = this.activeItem;
		const { sliderOffset, viewportWidth } = this;
		const pos = viewportWidth / 2 - width / 2 - offset + sliderOffset;
		this.slide(pos);
	}

	private slide(offset) {
		this.isSliding = true;
		this.sliderOffset = offset;
		this.slider.on('transitionend', () => this.isSliding = false);
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.viewport = $(window);
		this.document = $(document);
		this.slider = this.root.find('.gs-ScreenshotCarousel-items');
		this.prevButton = this.root.find('[role~="carousel"][role~="prev"]');
		this.nextButton = this.root.find('[role~="carousel"][role~="next"]');
		this.closeButton = this.root.find('[role~="close"]');

		this.prevButton.on('click', () => this.prev());
		this.nextButton.on('click', () => this.next());
		this.closeButton.on('click', () => screenshotCarousel.close());
		this.document.on('keydown.carousel', evt => this.handleKeydown(evt));
	}

	gsOnInit() {
		setTimeout(() => this.isOpen = true, 10);

		const src = this.root.data('gsScreenshotCarouselImage');
		const image = this.root.find(`[src*="${src}"]`);
		const active = image.closest('.gs-ScreenshotCarousel-item').gs(0);

		active.image.one('load', () => {
			active.select();
			this.isLoaded = true
		});
		this.gsOnWindowResize();
	}

	gsOnWindowResize() {
		this.viewportWidth = this.viewport.width();
		this.viewportHeight = this.viewport.height();
		this.widthClearance = Math.floor(this.viewportWidth * 0.15);
		this.heightClearance = Math.floor(this.viewportHeight * 0.15);
	}

	gsOnDestroy() {
		this.prevButton.off();
		this.nextButton.off();
		this.closeButton.off();
		this.document.off('keydown.carousel');
	}

	handleKeydown(evt) {
		if ($('input:focus').length > 0) return;
		if (this.isSliding) return evt.preventDefault();

		const key = evt.which || evt.keyCode;
		if (key == 37) this.prev();
		if (key == 39) this.next();
		if (key == 32 && evt.shiftKey) this.prev();
		if (key == 32 && !evt.shiftKey) this.next();
		if (key == 27) screenshotCarousel.close();
		evt.preventDefault();
	}
}
